import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'management-reports-sales-products-price-table',
  storeModule.createStoreModule('management-reports-sales-products-price-table')
)
